import { render, staticRenderFns } from "./CompanyBasicIntro.vue?vue&type=template&id=23aa10d9&scoped=true&"
import script from "./CompanyBasicIntro.vue?vue&type=script&lang=js&"
export * from "./CompanyBasicIntro.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBasicIntro.vue?vue&type=style&index=0&id=23aa10d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa10d9",
  null
  
)

export default component.exports